import { render, staticRenderFns } from "./TheAwaitingConfirmationIcon.vue?vue&type=template&id=8286383a&"
import script from "./TheAwaitingConfirmationIcon.vue?vue&type=script&lang=js&"
export * from "./TheAwaitingConfirmationIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports